import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type AlertDialogProps = {
  title: string;
  content: string;
  setIsOpen: (isOpen: boolean) => void;
  isOpen?: boolean;
  yesAction?: () => void;
  noAction?: () => void;
  yesLabel?: string;
  noLabel?: string;
  showNoButton?: boolean;
};

const defaultProps = {
  isOpen: false,
  yesAction: () => {},
  noAction: () => {},
  yesLabel: "Yes",
  noLabel: "No",
  showNoButton: true,
};
export default function AlertDialog(props: AlertDialogProps) {
  function closeAlertDialog() {
    props.setIsOpen(false);
  }
  function handleYes() {
    props.yesAction();
    closeAlertDialog();
  }

  function handleNo() {
    props.noAction();
    closeAlertDialog();
  }

  return (
    <Dialog
      open={props.isOpen}
      onClose={closeAlertDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.showNoButton && (
          <Button
            data-testid={"no-alert-dialog-button"}
            color={"secondary"}
            onClick={handleNo}
            variant={"outlined"}
          >
            {props.noLabel}
          </Button>
        )}
        <Button
          data-testid={"yes-alert-dialog-button"}
          color={"secondary"}
          onClick={handleYes}
          variant={"contained"}
        >
          {props.yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
AlertDialog.defaultProps = defaultProps;
